import {ServiceRequestService} from './../../../../../back-office/Services/service-request.service';
import {ServiceRequest} from './../../../../../back-office/Models/ServiceRequest';
import {Component, ViewChild, OnInit, OnDestroy} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {Subscription} from 'rxjs';

@Component({
  selector: 'app-select-solution',
  templateUrl: './select-solution.component.html',
  styleUrls: ['./select-solution.component.scss']
})
export class SelectSolutionComponent implements OnInit, OnDestroy {

  public solution: any;
  public serviceSubject: any;
  public request: ServiceRequest = new ServiceRequest();
  private subscriptions: Subscription[] = [];
  public solutions = [];
  public serviceSubjects = [];
  public solutionIsSelected = false;
  public serviceSubjectIsSelected = false;
  @ViewChild('confirmModal', {static: false}) confirmModal = null;
  @ViewChild('confirmCancelModal', {static: false}) confirmCancelModal = null;


  constructor(
    private translate: TranslateService,
    private requestService: ServiceRequestService,
  ) {
  }

  ngOnInit() {
    this.subscriptions.push(
      this.requestService.getServiceSubjects().subscribe(res => {
        let options = [];
        res.forEach(item => {
          options.push({value: item.id, label: item.name});
        });
        this.serviceSubjects = options;
        this.subscriptions.push(
          this.requestService.serviceRequest.subscribe(serviceRequest => {
            this.request = serviceRequest;
            if (this.request.reply) {
              this.solution = this.request.reply.solution.id;
              this.solutionIsSelected = true;
            }
          })
        );
      })
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  changeSolution(e) {

  }

  changeServiceSubject(serviceSubject) {
    this.subscriptions.push(
      this.requestService.getSolutions(serviceSubject).subscribe(res => {
        let options = [];
        res.forEach(item => {
          options.push({value: item.id, label: item.name});
        });
        this.solutions = options;
        this.serviceSubjectIsSelected = true;
      })
    );
  }

  selectSolution() {
    this.requestService.selectSolution(this.request.id, this.solution).subscribe(res => {
      this.confirmModal.hide();
      this.solutionIsSelected = true;
      this.requestService.fetchServiceRequestComplete(this.request.id);
    });
  }

  cancelSolution() {
    this.requestService.cancelSolution(this.request.id).subscribe(() => {
      this.confirmCancelModal.hide();
      this.solutionIsSelected = false;
      this.serviceSubject = null;
      this.solution = null;
      this.requestService.fetchServiceRequestComplete(this.request.id);
    });
  }

}
